import { Button, CircularProgress } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save';
import { useTranslation } from 'react-i18next'

type buttonProps = {
  onClick?: () => void
  className?: string
  disabled?: boolean
  isLoading?: boolean
  size?: "small" | "medium" | "large" | undefined
}
export const SaveButton = ({ onClick, isLoading, size, ...props }: buttonProps) => {
  const { t: transAction } = useTranslation('Action')

  return (
    <Button
      {...props}
      variant="contained"
      color="primary"
      onClick={onClick}
      size={size}
      startIcon={isLoading ? <CircularProgress size={20} color={'inherit'} /> : <SaveIcon />}
    >
      {transAction('GUARDAR')}      
    </Button>
  )
}
